import React from 'react';
import { Select, SelectOption } from '../../../../../../base/components/Forms/Select';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch } from '../../../../../../base/hooks';
import { HireStatusParams } from '../../../api/interfaces';
import { HireStatus } from '../../../enums';
import { responsesActions } from '../../../redux/slices/responsesSlice';
import { mapHireStatusToText } from '../../../utils';

import './styles.scss';

interface Props {
    responseId: number;
    hireStatus: HireStatus;
    markNewResponseAsReadHandler: () => void;
}

export const StatusSelect = ({ responseId, hireStatus, markNewResponseAsReadHandler }: Props) => {
    const dispatch = useAppDispatch();

    const statusSelectOptions: SelectOption[] = [
        {
            value: HireStatus.Invited,
            text: mapHireStatusToText(HireStatus.Invited),
            icon: (
                <Icon
                    icon='arrow-up-regular'
                    size='14px'
                    color='highlight'
                    className='responses-table-interactions-status-select__icon'
                />
            ),
        },
        {
            value: HireStatus.InProgress,
            text: mapHireStatusToText(HireStatus.InProgress),
            icon: (
                <Icon
                    icon='clock-regular'
                    size='14px'
                    color='info'
                    className='responses-table-interactions-status-select__icon'
                />
            ),
        },
        {
            value: HireStatus.Hired,
            text: mapHireStatusToText(HireStatus.Hired),
            icon: (
                <Icon
                    icon='check'
                    size='14px'
                    color='success'
                    className='responses-table-interactions-status-select__icon'
                />
            ),
        },
    ];

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(responsesActions.setResponseStatusRequest(responseId, value as HireStatusParams));
    };

    return (
        <div onClick={markNewResponseAsReadHandler}>
            <Select
                id='statusSelect'
                value={hireStatus}
                options={statusSelectOptions}
                onChange={inputChangeHandler}
                className='responses-table-interactions-status-select'
                dropdownClassname='responses-table-interactions-status-select__dropdown'
            />
        </div>
    );
};
